function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "check_white_checkbox");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.87,0a6.83,6.83,0,0,0-4.71,2.08c-17,17.06-35.23,36.6-52.24,53.84L11.66,36a6.86,6.86,0,1,0-9.6,9.8A6,6,0,0,0,3,46.5l29.14,24a6.86,6.86,0,0,0,9.22-.42C59.76,51.61,79.76,30,97.91,11.79A6.85,6.85,0,0,0,92.87,0Z",
  fill: "#fff"
});

var SvgCheckWhiteCheckbox = function SvgCheckWhiteCheckbox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 72.08,
    viewBox: "0 0 100 72.08",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckWhiteCheckbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check_white_checkbox.26f52f3b.svg";
export { ForwardRef as ReactComponent };